/**
 * Created by jv on 31/01/2017.
 */
const utils = require("Sources/utils/utils");

// style
require("Styles/components/input-spinner.scss");

$.fn.spinner = function(options, extra)
{
  var returnValue = this;
  var pluginID = "fundels-spinner";

  this.each(function()
  {
    var $this = $(this);
    var spinner = $this.data(pluginID);

    if (!(spinner instanceof Spinner))
    {
      $this.data(pluginID, new Spinner($.extend({
        element: this
      }, options)));
    }

    if(spinner && utils.isString(options))
    {
      if(options === "get")
      {
        returnValue = spinner.value;
      }
      else if (options === "destroy")
      {
        spinner.destroy();
        $this.removeData(pluginID);
      }
      else
      {
        var method = spinner.getAction(options);

        if(utils.isNull(method))
        {
          throw new Error("FundelsSpinner: no such method: '" + options + "'");
        }

        method.call(spinner, extra);
      }
    }
  });

  return returnValue;
};

var Spinner = class Spinner
{
  constructor(options)
  {
    /*
     * options.key
     * options.element
     * options.appendTo
     *
     * options.initialValue (default: 0)
     * options.minValue      (default: Number.MIN_SAFE_INTEGER)
     * options.maxValue      (default: Number.MAX_SAFE_INTEGER)
     * options.step          (default: 1)
     *
     * options.allowDecrease (default: true)
     * options.allowIncrease (default: true)
     *
     * events: (trigger)
     *  spinner:before-change
     *  spinner:change
     *  spinner:step-up
     *  spinner:step-down
     */

    if(utils.isNull(options))
    {
      throw "options must be defined";
    }

    this.key = options.key;
    this.element = utils.isNotNull(options.element) ? $(options.element) : null;
    this.appendTo = utils.isNotNull(options.appendTo) ? $(options.appendTo) : null;

    this.spinnerElement = null;

    this.initialValue = utils.isNumber(options.initialValue) ? options.initialValue : 0;
    this.value = this.initialValue;
    this.minValue = utils.isNumber(options.minValue) ? options.minValue : utils.getMinSafeInt();
    this.maxValue = utils.isNumber(options.maxValue) ? options.maxValue : utils.getMaxSafeInt();
    this.step = utils.isNumber(options.step) ? options.step : 1;

    this.allowDecrease = utils.isBoolean(options.allowDecrease) ? options.allowDecrease : true;
    this.allowIncrease = utils.isBoolean(options.allowIncrease) ? options.allowIncrease : true;

    this.beforeChange = options.beforeChange;
    this.onStepDown = options.onStepDown;
    this.onStepUp = options.onStepUp;
    this.onChange = options.onChange;

    this.create();
  }

  create()
  {
    if(this._initialized !== true)
    {
      this.spinnerElement = $("<div class='input-spinner'></div>");

      this.rerender();

      if(utils.isNotNull(this.element) && this.element.length)
      {
        this.element.hide();
        this.element.after(this.spinnerElement);
      }
      else if(utils.isNotNull(this.appendTo) && this.appendTo.length)
      {
        this.appendTo.append(this.spinnerElement);
      }

      this._initialized = true;
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.spinnerElement) && this.spinnerElement.length)
    {
      this.spinnerElement.remove();
    }

    if(utils.isNotNull(this.element) && this.element.length)
    {
      this.element.val(this.value).show();
    }

    this._initialized = false;
  }

  rerender()
  {
    this.spinnerElement.empty();

    // DecreaseBtn
    var decreaseBtn = "<button class='btn btn-icon frameless minus-circle dark-grey spinner-decrease'></button>";
    // ValueDisplay
    var valueDisplay = "<div class='spinner-value'>" + this.value + "</div>";
    // IncreaseBtn
    var increaseBtn = "<button class='btn btn-icon frameless add-circle dark-grey spinner-increase'></button>";

    this.spinnerElement.append(decreaseBtn + valueDisplay + increaseBtn);

    this.toggleStepBtns();
    this.setUpEventListeners();
  }

  setUpEventListeners()
  {
    var that = this;

    if(utils.isNotNull(that.spinnerElement) && that.spinnerElement.length)
    {
      that.spinnerElement.find(".spinner-decrease").off().on("click", function(e)
      {
        that.decrease();
      });

      that.spinnerElement.find(".spinner-increase").off().on("click", function(e)
      {
        that.increase();
      });
    }
  }

  decrease()
  {
    if(!this.allowDecrease || this.value <= this.minValue)
    {
      this.toggleStepBtns();
      return;
    }

    this.triggerBeforeChange();

    this.value = this.value - this.step;

    if(this.value < this.minValue)
    {
      this.value = this.minValue;
    }

    this.toggleStepBtns();
    this.spinnerElement.find(".spinner-value").text(this.value);

    this.triggerStepDown();
    this.triggerOnChange();
  }

  increase()
  {
    if(!this.allowIncrease || this.value >= this.maxValue)
    {
      this.toggleStepBtns();
      return;
    }

    this.triggerBeforeChange();

    this.value = this.value + this.step;

    if(this.value > this.maxValue)
    {
      this.value = this.maxValue;
    }

    this.toggleStepBtns();
    this.spinnerElement.find(".spinner-value").text(this.value);

    this.triggerStepUp();
    this.triggerOnChange();
  }

  toggleStepBtns()
  {
    if(this.allowDecrease)
    {
      if(this.value <= this.minValue)
      {
        this.disableStepBtn("decrease");
      }
      else
      {
        this.enableStepBtn("decrease");
      }
    }
    else
    {
      this.disableStepBtn("decrease");
    }

    if(this.allowIncrease)
    {
      if(this.value >= this.maxValue)
      {
        this.disableStepBtn("increase");
      }
      else
      {
        this.enableStepBtn("increase");
      }
    }
    else
    {
      this.disableStepBtn("increase");
    }
  }

  enableStepBtn(type)
  {
    this.spinnerElement.find(".spinner-" + type).removeClass("disabled");
  }

  disableStepBtn(type)
  {
    var stepBtn = this.spinnerElement.find(".spinner-" + type);

    if(!stepBtn.hasClass("disabled"))
    {
      stepBtn.addClass("disabled");
    }
  }

  triggerBeforeChange()
  {
    if(utils.isNotNull(this.element) && this.element.length)
    {
      this.element.trigger("spinner:before-change", [ this ]);
    }
    else
    {
      this.spinnerElement.trigger("spinner:before-change", [ this ]);
    }

    if(utils.isFunction(this.beforeChange))
    {
      this.beforeChange();
    }
  }

  triggerStepDown()
  {
    if(utils.isNotNull(this.element) && this.element.length)
    {
      this.element.trigger("spinner:step-down", [ this ]);
    }
    else
    {
      this.spinnerElement.trigger("spinner:step-down", [ this ]);
    }

    if(utils.isFunction(this.onStepDown))
    {
      this.onStepDown();
    }
  }

  triggerStepUp()
  {
    if(utils.isNotNull(this.element) && this.element.length)
    {
      this.element.trigger("spinner:step-up", [ this ]);
    }
    else
    {
      this.spinnerElement.trigger("spinner:step-up", [ this ]);
    }

    if(utils.isFunction(this.onStepUp))
    {
      this.onStepUp();
    }
  }

  triggerOnChange()
  {
    if(utils.isNotNull(this.element) && this.element.length)
    {
      this.element.trigger("spinner:change", [ this ]);
    }
    else
    {
      this.spinnerElement.trigger("spinner:change", [ this ]);
    }

    if(utils.isFunction(this.onChange))
    {
      this.onChange();
    }
  }

  setValue(val)
  {
    // Does not trigger any events
    val = val < this.minValue ? this.minValue : val;
    val = val > this.maxValue ? this.maxValue : val;

    this.value = val;
    if(utils.isNotNull(this.spinnerElement) && this.spinnerElement.length)
    {
      this.spinnerElement.find(".spinner-value").text(this.value);
    }
  }

  disable()
  {
    this.allowIncrease = false;
    this.allowDecrease = false;

    this.toggleStepBtns();
  }

  enable()
  {
    this.allowDecrease = true;
    this.allowIncrease = true;

    this.toggleStepBtns();
  }

  getAction(action)
  {
    switch(action)
    {
      case "set":
        return this.setValue;
      case "disable":
        return this.disable;
      default:
        return null;
    }
  }
};

module.exports = Spinner;



// WEBPACK FOOTER //
// ./app/js/components/input-spinner.js